'use strict';

angular.module('shiftTraderApp')
  .controller('MwpBudgetingCtrl', function ($scope, ServerUrls, $location, $rootScope,
                                            WorkPeriodStore, $q, Session, TimeService,
                                            $timeout, Projections, WeekCalculationService) {
    var lastWeekNum;
    var calcLater = false;
    var hasBeenInitialized = false;
    $scope.workDayHourStart = Session.getWorkDayStartHour();

    // preset this so that the ngRepeat can build out the footer bar
    $scope.dates = [0,1,2,3,4,5,6];

    $scope.dataByDay = [];
    // Need to pull the whole week with 1 day before just in case shifts run over from last week into this week

    $scope.dayIndex = -1;

    var viewSelectionFromSession = Session.getMwpBudgetingSelection();
    if (viewSelectionFromSession) {
      $scope.currentView = viewSelectionFromSession;
    } else {
      $scope.currentView = 'laborHours'; // 'laborPercentage', 'laborHours'
    }

    $scope.toggleCurrentView = function() {
      if ($scope.currentView === 'laborHours') {
        $scope.currentView = 'cost';
      } else if ($scope.currentView === 'cost') {
        $scope.currentView = 'laborPercentage';
      } else if ($scope.currentView === 'laborPercentage') {
        $scope.currentView = 'productivity';
      } else if ($scope.currentView === 'productivity') {
        $scope.currentView = 'laborHours';
      } else {
        $scope.currentView = 'laborHours';
      }

      Session.setMwpBudgetingSelection($scope.currentView);
      calculateAllTheNumbers();
    };

    var getProjections = function() {
      Projections.getAll({
        organization_id: Session.getCurrentOrgId(),
        start_date: $scope.dates[0].format('YYYY-MM-DD'),
        end_date: $scope.dates[6].format('YYYY-MM-DD'),
        active: true
      })
        .then(function(projections) {
          //console.log('projections', projections);

          var weekLaborPercGoal = _.find(projections, {type: 'weekly'});

          $scope.projectionsData = {
            weekLaborPercentageGoal: weekLaborPercGoal ? weekLaborPercGoal.week_labor_percentage_goal : null,
            byDay: _.map($scope.dates, function(dt) {
              var matchingProj = _.find(projections, {target_date: dt.format('YYYY-MM-DD')});

              if (matchingProj) {
                return matchingProj;
              } else {
                return {
                  data: {
                    total: {
                      cost: null,
                      gross_revenue: null,
                      labor_hours: null
                    }
                  }
                }
              }
            })
          };
          calculateAllTheNumbers();
        }, function() {
          console.log('error retreiving projections');
        });
    };

    $scope.$on('sa:manageWorkPeriod:dateChange', function(event, newDate) {
      //window.logTime((event.name + ' ' + newDate.format());
      //console.log('sa:manageWorkPeriod:dateChange', newDate.format());
      //console.log(event);
      if (_.isUndefined(newDate)) {
        newDate = $scope.currentDate;
      }
      initDates(newDate);
      hasBeenInitialized = true;
      getProjections();
    });

    var initDates = function(newDate) {
      $scope.weekTwix = TimeService.getWeekTwixFromMoment(newDate, 0, 0, true);
      $scope.beginningOfWeek = moment($scope.weekTwix.start);
      $scope.weekNumber = TimeService.getWorkWeekNumberFromMoment(newDate);
      var tempDay;
      if ($scope.weekNumber !== lastWeekNum) {
        $scope.budgetDataByDay = [null, null, null, null, null, null, null];
        $scope.$broadcast('sa:manageWorkPeriod:projectionsWeekProcessingStatus', false);
      }
      $scope.dates = _.map([0,1,2,3,4,5,6], function(num) {
        tempDay = moment($scope.beginningOfWeek).add(num, 'days');
//        console.log(num, tempDay.format(), tempDay.day(), newDate.day());
        if (tempDay.isSame(newDate, 'day')) {
//          console.log('tempDay.day is same as newDate.day', tempDay.day(), num);
          $scope.dayIndex = num;
        }
        return tempDay;
      });

      $rootScope.$broadcast('sa:manageWorkPeriod:DayIndexUpdated', $scope.dayIndex);
    };

    $scope.$on('sa:manageWorkPeriod:WorkPeriodStoreUpdated', function(event, newDate) {
      //console.log('$ON footerLeft: sa:manageWorkPeriod:WorkPeriodStoreUpdated', newDate.format());
      if (!hasBeenInitialized) {
        initDates(newDate);
      }

      $scope.$broadcast('sa:manageWorkPeriod:projectionsWeekProcessingStatus', false);
      //console.log(lastWeekNum, $scope.weekNumber);
      processWeeksWorkPeriods($scope.beginningOfWeek);
      lastWeekNum = $scope.weekNumber;
      $scope.currentDate = newDate;
    });


    var processWeeksWorkPeriods = function(beginningOfWeek) {
      //console.log('processWeeksWorkPeriods');
      WorkPeriodStore.getWorkPeriodsBetween(moment(beginningOfWeek).subtract(1,'days'), moment(beginningOfWeek).add(7, 'days'))
          .then(function(wps) {
            $scope.workPeriodOverlapsByDay = _.map($scope.dates, function(dt) {
              var dtTwix = moment(dt).twix(moment(dt).add(1, 'days'));

              return _.where(wps, function(wp) {
                return wp.range_twix.overlaps(dtTwix) && Math.abs(wp.range_twix.intersection(dtTwix).length('minutes')) > 0;
              });
            });

            if (_.isUndefined($scope.orgData) || _.isNull($scope.orgData)) {
              calcLater = true;
            } else {
              calculateAllTheNumbers();
            }
          });
    };

    $scope.publishDay = function () {
      $rootScope.$broadcast('publishDay');
    };

    $scope.publishWeek = function() {
      $rootScope.$broadcast('publishWeek');
    };

    $scope.changeDay = function(dayIndex) {
      if (dayIndex !== $scope.dayIndex) {
        $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {moment: $scope.dates[dayIndex]});
        $scope.dayIndex = dayIndex;
      }
    };

    $scope.changeWeek = function(direction) {
      $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {
        delta: {
          interval: 'weeks',
          numIntervals: direction
        }
      });
    };

    // this is used to get department/position data from manageWorkPeriods for the budget tooltips
    $scope.$on('sa:updatedOrgData', function(event, data) {
      //console.log('sa:updatedOrgData');
      $scope.orgData = data;

      if (calcLater) {
        calculateAllTheNumbers();
        // we probably missed the dateChange event onPageLoad, so do it here
        getProjections();
      }
    });

    var calculateAllTheNumbers = function() {
      //console.log('entering: calculateAllTheNumbers');

      $scope.dayAnalysisDataByDay = WeekCalculationService.calcWeekWorkPeriodStats($scope.dates,
        $scope.workPeriodOverlapsByDay,
        $scope.orgData.departments, $scope.orgData);


      $timeout(function() {
        $scope.$broadcast('sa:manageWorkPeriod:projectionsWeekProcessingStatus', {
          projections: $scope.projectionsData,
          dayAnalysisDataByDay: $scope.dayAnalysisDataByDay,
          currentView: $scope.currentView,
          org: $scope.orgData,
          dayIndex: $scope.dayIndex
        });
        $rootScope.$broadcast('sa:manageWorkPeriod:WeekPublishDataUpdated', $scope.dayAnalysisDataByDay);
      }, 0);
    };

    $scope.$on('sa:manageWorkPeriod:projectionsUpdated', function() {
      getProjections();
    });

  });
